import React from 'react';

function AdminProjects() {
  return (
    <div>
      <h1>Admin Projects</h1>
    </div>
  );
}

export default AdminProjects;
